
import { useState, useEffect } from 'react';
import { northStarMetricsService, NorthStarMetrics } from '@/services/analytics/northStarMetrics';
import { useToast } from '@/hooks/use-toast';

export const useNorthStarMetrics = () => {
  const [metrics, setMetrics] = useState<NorthStarMetrics | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const { toast } = useToast();

  const loadMetrics = async () => {
    try {
      setIsLoading(true);
      setError(null);
      
      console.log('Loading North Star metrics...');
      const metricsData = await northStarMetricsService.getNorthStarMetrics();
      
      console.log('North Star metrics loaded:', metricsData);
      setMetrics(metricsData);
    } catch (error) {
      console.error('Error loading North Star metrics:', error);
      setError(error instanceof Error ? error.message : 'Failed to load metrics');
      toast({
        title: "Error loading metrics",
        description: "Failed to load North Star metrics. Please try again.",
        variant: "destructive"
      });
    } finally {
      setIsLoading(false);
    }
  };

  const refreshMetrics = () => {
    loadMetrics();
  };

  useEffect(() => {
    loadMetrics();
  }, []);

  return {
    metrics,
    isLoading,
    error,
    refreshMetrics
  };
};
